import list from './groupWelcomeResources'
export default list
